import axios from "axios";
import PageTitle from "components/PageTitle";
import React, { useEffect, useState } from "react";
import ListagemVerbalizacao from "./Verbalizacoes";
import { Card } from "react-bootstrap";
import TaxaAdesaoChart from "./TaxaAdesao";
import RespondentesChart from "./Respondentes";
import DashboardPorColaborador from "./PorColaborador";

export interface IResposta {
  id: number,
  resposta: number,
  usuario_id: number,
  observacao: string | null,
  autoavaliacaocampo_id: number | null;
  created_at: string
  usuario: {
    id: number,
    nome: string,
  }
  campo: {
    id: number,
    titulo: string,
    peso: number
    opcoes: {
      label: string,
      valor: number
    }[]
  } | null
}

interface IDashboard {
  respostas : IResposta[]
}

export default function AutoavaliacaoDashboard() {

  // const [dashboard, setDashboard] = useState()
  // useEffect(()=>{
  //   const fetchDashboard = async () => {
  //     const resp = (await axios.get('/autoavaliacao-resposta/dashboard')).data
  //     console.log(resp)
  //     setDashboard(resp)
  //   }
  //   fetchDashboard()
  // },[])

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: "Autoavaliação", path: "/#", active: false },
          {
            label: "Dashboard",
            path: "/autoavaliacao-superiores/dashboard",
            active: true,
          },
        ]}
        title={"Dashboard de Autoavaliações"}
      />

      <TaxaAdesaoChart/>
      <RespondentesChart/>
      <DashboardPorColaborador/>
      <Card>
        <Card.Body>
          <ListagemVerbalizacao
            title="Verbalizações"
          />          
        </Card.Body>
      </Card>
    </>
  );
}
